import { atom, useAtom, useSetAtom } from 'jotai';

const isArchivedVersionAtom = atom<boolean>(false);

export const useIsArchivedVersion = () => {
  return useAtom(isArchivedVersionAtom);
};

export const useSetIsArchivedVersion = () => {
  return useSetAtom(isArchivedVersionAtom);
};
